import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "lib/i18n/use-translation";

import {
  AuthLayout,
  PrimaryButton,
} from "apps/user/common/components/auth-layout";

// Video lives in public/ rather than src/Assets/ so it's served by the
// static middleware directly. Going through webpack-dev-server's memfs
// streamed reads (CRA's bundler default) crashed Node 20 on large media
// files via a known memfs-on-newer-node bug.
const INTRO_VIDEO_URL = `${process.env.PUBLIC_URL || ""}/videos/wone-intro.mp4`;
const INTRO_SOURCES = [{ src: INTRO_VIDEO_URL, type: "video/mp4" }];

const GetStarted: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation(["auth", "common"]);

  return (
    <AuthLayout
      variant="intro"
      videoSources={INTRO_SOURCES}
      tagline={
        <>
          {t("auth:getStarted.taglineLine1")}
          <br />
          {t("auth:getStarted.taglineLine2")}
        </>
      }
    >
      {/* WONE-612: single CTA — sign-in vs sign-up branching happens
          server-side via learnerAuthMethods(email) on the next screen. */}
      <PrimaryButton overlay onClick={() => navigate("/email-entry")}>
        {t("common:action.continue")}
      </PrimaryButton>
    </AuthLayout>
  );
};

export default GetStarted;
